export const DOCUMENT_WARRANTIES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Warranty.DocumentWarrantyDataUpdated";
export const WARRANTIES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Warranty.DocumentWarrantyDataInvalidated";
